import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCryengineComponent } from './simple-icons-cryengine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCryengineComponent ],
    exports:      [ SimpleIconsCryengineComponent ],
    bootstrap:    []
})
export class SimpleIconsCryengineModule {}
